import { render } from "./SlideButton.vue?vue&type=template&id=6d95fd34"
import script from "./SlideButton.vue?vue&type=script&lang=js"
export * from "./SlideButton.vue?vue&type=script&lang=js"

import "./SlideButton.vue?vue&type=style&index=0&id=6d95fd34&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__